module.exports = __webpack_public_path__ + "img/30.7.Chla.250b720c.png";